export default {
  paymentMethods: null,
  paymentMethodsDeliveryTypes: [
    { id: "PLIN", name: "Plin" },
    { id: "YAPE", name: "Yape" },
    { id: "CASH", name: "Efectivo" },
  ],
};
